import React, { Component } from "react";
import { Divider, Tabs, Collapse } from "antd";
import { withRouter } from 'react-router-dom';
import All from "./All";
import Upcoming from "./Upcoming";
import InDevelopment from "./InDevelopment";
import Released from "./Released";
import Active from "./Active";
import Closed from "./Closed";
import ChecklistNA from "./ChecklistNA";
import Admin from "./Admin";
import {
    isCreatorOrAdministrator,
    isExternalContributorOrExternalView,
    isIPSDataCreatorOrAdministrator
} from "../../utils/UserInfo";
import SearchBar from "../../components/SearchBar";
import {
    getStations,
    getTFSPCAreas,
    getTfStationAreas,
    getStationRegions,
    getBPIDs,
    getMPIDs,
    getAllProjectWOs, getUserProfile, getUserProjects, getIpsStations, getIPSDTUserProjects
} from "../../api";
import moment from "moment";
import './dashboard.css';
import { projectStatusMap } from "../../components/ProjectStatusMap";
import { routesActiveTabMap } from '../../components/ProjectStatusCodeMap';
import Cookies from 'js-cookie'
import DataTrackerAll from "./DataTrackerAll";
import DataTrackerNA from "./DataTrackerNA";
import DataTrackerComplete from "./DataTrackerComplete";
import DataTrackerProgress from "./DataTrackerProgress";
import DataTrackerPending from "./DataTrackerPending";
import DataTrackerMatchedDuplicate from "./DataTrackerMatchedDuplicate";
import DataTrackerTabs from "./DataTrackerTabs";
import FMPTrackerTabs from "./FMPTrackerTabs";
import FMPTrackerAll from "./FMPTrackerAll";
import FMPTrackerPending from "./FMPTrackerPending";
import FMPTrackerProgress from "./FMPTrackerProgress";
import ChecklistTabs from "./ChecklistTabs";
import DataTrackerHold from "./DataTrackerHold";
import FMPTrackerReview from "./FMPTrackerReview";
import FMPTrackerASBuilts from "./FMPTrackerASBuilts";
import FMPTrackerComplete from "./FMPTrackerComplete";

const TabPane = Tabs.TabPane;

const padfix = {
    margin: '16px 16px 16px',
    border: '1px solid #f0f0f0',

};

const navMenuHeaderStyle = {
    style1 : { 
    padding: '12px', 
    backgroundColor: '#0CA0DA', 
    color: 'rgb(255, 255, 255)'
    },
    style0: {
        padding: '12px', 
        backgroundColor: '#f0f0f0'
    }
}

class NavBar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            station: "",
            status: "",
            cardview: "cardview",
            stations: [],
            ipsStations: [],
            searchProject: {
                stationName: "",
                bpid: "",
                mpid: '',
                workOrder: "",
                constructionStartDate: "",
                constructionEndDate: "",
                commisioningStartDate: "",
                commisioningEndDate: "",
                expectedCloseStartDate: "",
                expectedCloseEndDate: "",
                constructionDateNull: false,
                commisioningDateNull: false,
                expectedDateNull: false,
                inServiceStartDate: "",
                inServiceEndDate: "",
                inServiceDateNull: false,
                selectedStationRegions: [],
                selectedStationAreas: [],
                selectedPCAreas: [],
                setStationFilter: this.setStationFilter.bind(this),
                selectedStation: this.setStationFilter.bind(this),
                setSelectedStationRegion: this.setSelectedStationRegion.bind(this),
                setSelectedStationAreas: this.setSelectedStationAreas.bind(this),
                setSelectedPCAreas: this.setSelectedPCAreas.bind(this),
                setBPID: this.setBPID.bind(this),
                setWorkOrder: this.setWorkOrder.bind(this),
                setConstructionStartDate: this.setConstructionStartDate.bind(this),
                setConstructionEndDate: this.setConstructionEndDate.bind(this),
                setNullConstructionDate: this.setNullConstructionDate.bind(this),
                setNullInServiceDate: this.setNullInServiceDate.bind(this),
                setInServiceStartDate: this.setInServiceStartDate.bind(this),
                setInServiceEndDate: this.setInServiceEndDate.bind(this),
                setCommisioningStartDate: this.setCommisioningStartDate.bind(this),
                setCommisioningEndDate: this.setCommisioningEndDate.bind(this),
                setNullCommisioningDate: this.setNullCommisioningDate.bind(this),
                setNullExpectedDate: this.setNullExpectedDate.bind(this),
                setExpectedCloseStartDate: this.setExpectedCloseStartDate.bind(this),
                setExpectedCloseEndDate: this.setExpectedCloseEndDate.bind(this),
                selectedBPID: this.setBPID.bind(this),
                selectedMPID: this.setMPID.bind(this),
                selectedWorkOrder: this.setWorkOrder.bind(this),
                onChangeConstructionStartDate: this.setConstructionStartDate.bind(this),
                onChangeConstructionEndDate: this.setConstructionEndDate.bind(this),
                onChangeInServiceStartDate: this.setInServiceStartDate.bind(this),
                onChangeInServiceEndDate: this.setInServiceEndDate.bind(this),
                onChangeCommisioningStartDate: this.setCommisioningStartDate.bind(this),
                onChangeCommisioningEndDate: this.setCommisioningEndDate.bind(this),
                onChangeExpectedCloseStartDate: this.setExpectedCloseStartDate.bind(this),
                onChangeExpectedCloseEndDate: this.setExpectedCloseEndDate.bind(this),
                myProjectsFlag: null,
                setMyProjectsFlag: this.setMyProjectsFlag.bind(this),
                activeCollapsePanels: []
            },
            pcAreas: [],
            stationAreas: [],
            stationRegions: [],
            bpIds: [],
            mpIds: [],
            workOrders: [],
            myProjects: [],
            myIPSDTProjects: [],
            activeTabKey: '',
        };
        this.projectsList = this.projectsList.bind(this);
        this.onClear = this.onClear.bind(this);
    }

    async componentDidMount() {
        const { stations, ipsStations } = this.state;
        if ((stations && stations.length < 1)) {
            const allStations = await getStations({ status: "" });
            this.setState({ stations: allStations })
        }
        if ((!isExternalContributorOrExternalView() && ipsStations && ipsStations.length < 1)) {
            const allIPSStations = await getIpsStations({ status: "" });
            this.setState({ ipsStations: allIPSStations })
        }
        //Station Regions
        const StationRegionsResponse = await getStationRegions();
        const stationRegions = StationRegionsResponse.data.map(region => {
            return { name: region }
        });
        this.setState({ stationRegions });

        //Station Areas
        const TFSStationAreasResponse = await getTfStationAreas();
        const stationAreas = TFSStationAreasResponse.data.map(area => {
            return { name: area }
        });
        this.setState({ stationAreas });

        //PC Areas
        const TFSPCAreasResponse = await getTFSPCAreas();
        const pcAreas = TFSPCAreasResponse.data.map(area => {
            return { name: area }
        });
        this.setState({ pcAreas });

        //BPId's
        const BPIDsResponse = await getBPIDs();
        const bpIds = BPIDsResponse.data.map(bpid => {
            return { name: bpid }
        });
        this.setState({ bpIds });

        //MPId's
        const MPIDsResponse = await getMPIDs();
        const mpIds = MPIDsResponse.data.map(mpid => {
            return { name: mpid }
        });
        this.setState({ mpIds });

        //workOrders
        const workOrdersResponse = await getAllProjectWOs();
        const workOrders = workOrdersResponse.data.map(workOrder => {
            return { name: workOrder }
        });
        this.setState({ workOrders });

        //userProfile
        const { context } = this.props;
        const userProfile = context.state.userProfile;

        //myProjects
        const myProjects = await getUserProjects();
        this.setState({ myProjects });

        // getIPS DT PROJECT LIST FOR MY PROJECT
        if(!isExternalContributorOrExternalView()) {
            const myIPSDTProjects = await getIPSDTUserProjects();
            this.setState({myIPSDTProjects});
        }
        //const myProjectResponse = await Promise.allSettled([myProjects, myIPSDTProjects])
        //this.setState({
            //myProjects: myProjectResponse[0].value,
            //myIPSDTProjects: myProjectResponse[1].value
        //})
        let searchProject = this.state.searchProject;
        const getFilterSelectionCookieJson = Cookies.get('filters');
        const parsedFilterSelectionsJson = getFilterSelectionCookieJson ? JSON.parse(getFilterSelectionCookieJson) : {};

        searchProject.selectedStationRegions = parsedFilterSelectionsJson && parsedFilterSelectionsJson.selectedStatRegs ? parsedFilterSelectionsJson.selectedStatRegs : [];
        searchProject.selectedStationAreas = parsedFilterSelectionsJson && parsedFilterSelectionsJson.selectedStatAreas ? parsedFilterSelectionsJson.selectedStatAreas : [];
        searchProject.selectedPCAreas = parsedFilterSelectionsJson && parsedFilterSelectionsJson.selectedPCAreas ? parsedFilterSelectionsJson.selectedPCAreas : [];
        searchProject.myProjectsFlag = parsedFilterSelectionsJson && parsedFilterSelectionsJson.selectedProjFlag;




        this.setState({ searchProject: searchProject });

        const routeActiveTab = this.getActiveCurrentTab();
        if (routeActiveTab) {
            this.setState({ activeTabKey: routeActiveTab });
        } else {
            this.setState({
                activeTabKey: ((parsedFilterSelectionsJson && parsedFilterSelectionsJson.selectedDefaultDashView) ? projectStatusMap[parsedFilterSelectionsJson.selectedDefaultDashView] :
                    ((parsedFilterSelectionsJson && !parsedFilterSelectionsJson.selectedDefaultDashView) ? 'all' : 'upcoming'))
            });
        }

    }

    projectsList(projects) {
        let searchProject = this.state.searchProject;

        let projectList = projects;

        if (searchProject) {
            const getFilterSelectionCookieJson = Cookies.get('filters');
            const parsedFilterSelectionsJson = getFilterSelectionCookieJson ? JSON.parse(getFilterSelectionCookieJson) : {};
            projectList = (searchProject.stationName) ? projects.filter(proj => searchProject.stationName === proj.stationName) : projectList;
            projectList = (parsedFilterSelectionsJson.selectedStatRegs && parsedFilterSelectionsJson.selectedStatRegs.length > 0) ? projectList.filter(proj => proj.stationRegion && parsedFilterSelectionsJson.selectedStatRegs.includes(proj.stationRegion)) : projectList;
            projectList = (parsedFilterSelectionsJson.selectedStatAreas && parsedFilterSelectionsJson.selectedStatAreas.length > 0) ? projectList.filter(proj => proj.tfStationArea && parsedFilterSelectionsJson.selectedStatAreas.includes(proj.tfStationArea)) : projectList;
            projectList = (parsedFilterSelectionsJson.selectedPCAreas && parsedFilterSelectionsJson.selectedPCAreas.length > 0) ? projectList.filter(proj => proj.pcArea && parsedFilterSelectionsJson.selectedPCAreas.includes(proj.pcArea)) : projectList;

            projectList = (searchProject.bpid && searchProject.bpid.length > 0) ? projectList.filter(proj => {
                return (
                    (proj.bpid && proj.bpid.indexOf(searchProject.bpid) !== -1)
                    ||
                    // check for removalBPID 
                    (proj.removalBPID && proj.removalBPID.indexOf(searchProject.bpid) !== -1)
                )
            }) : projectList;


            projectList = (searchProject.mpid && searchProject.mpid.length > 0) ? projectList.filter(proj => proj.mpid && proj.mpid.indexOf(searchProject.mpid) !== -1) : projectList;


            projectList = (searchProject.workOrder && searchProject.workOrder.length > 0) ? projectList.filter(proj => {
                return (
                    (proj.workOrder && proj.workOrder.indexOf(searchProject.workOrder) !== -1)
                    ||
                    (proj.removalWO && proj.removalWO.indexOf(searchProject.workOrder) !== -1)
                )
            }) : projectList;


            projectList = ((searchProject.constructionStartDate && searchProject.constructionStartDate.length > 0) && (searchProject.constructionEndDate && searchProject.constructionEndDate.length > 0)) ? projectList.filter(proj => (moment(proj.constructionStartDate) >= moment(searchProject.constructionStartDate)) && (moment(proj.constructionStartDate) <= moment(searchProject.constructionEndDate))) : projectList;

            projectList = ((searchProject.inServiceStartDate && searchProject.inServiceStartDate.length > 0) && (searchProject.inServiceEndDate && searchProject.inServiceEndDate.length > 0)) ? projectList.filter(proj => (moment(proj.inServiceDate) >= moment(searchProject.inServiceStartDate)) && (moment(proj.inServiceDate) <= moment(searchProject.inServiceEndDate))) : projectList;

            projectList = ((searchProject.commisioningStartDate && searchProject.commisioningStartDate.length > 0) && (searchProject.commisioningEndDate && searchProject.commisioningEndDate.length > 0)) ? projectList.filter(proj => (moment(proj.commisioningStartDate || (proj.tclReleaseDate ?proj.tclReleaseDate :'1900-01-01')) >= moment(searchProject.commisioningStartDate)) && (moment(proj.commisioningStartDate ||  (proj.tclReleaseDate ?proj.tclReleaseDate :'1900-01-01')) <= moment(searchProject.commisioningEndDate))) : projectList;

            projectList = ((searchProject.expectedCloseStartDate && searchProject.expectedCloseStartDate.length > 0) && (searchProject.expectedCloseEndDate && searchProject.expectedCloseEndDate.length > 0)) ? projectList.filter(proj => (moment(proj.defExpectedCloseDate ? proj.defExpectedCloseDate : proj.expectedCloseDate) >= moment(searchProject.expectedCloseStartDate)) && (moment(proj.defExpectedCloseDate ? proj.defExpectedCloseDate : proj.expectedCloseDate) <= moment(searchProject.expectedCloseEndDate))) : projectList;



            projectList = (searchProject.constructionDateNull) ? projectList.filter(proj => (proj.constructionStartDate === null)) : projectList;
            projectList = (searchProject.inServiceDateNull) ? projectList.filter(proj => (proj.inServiceDate === null)) : projectList;
            projectList = (searchProject.commisioningDateNull) ? projectList.filter(proj => (proj.commisioningStartDate === null || proj.tclReleaseDate === null)) : projectList;
            projectList = (searchProject.expectedDateNull) ? projectList.filter(proj => (proj.defExpectedCloseDate === null)) : projectList;


            projectList = (parsedFilterSelectionsJson && parsedFilterSelectionsJson.selectedProjFlag === 'Y') ? projectList.filter(proj => this.state.myProjects.includes(proj.id) || this.state.myIPSDTProjects.includes(proj.bpid)) : projectList;

            projectList = (parsedFilterSelectionsJson && parsedFilterSelectionsJson.selectedProjFlag === 'N') ? projectList.filter(proj => !this.state.myProjects.includes(proj.id) || !this.state.myIPSDTProjects.includes(proj.bpid)) : projectList;
        }

        return projectList;
    }

    async setStationFilter(name) {
        let project = this.state.searchProject;
        project.stationName = name;
        this.setState({ searchProject: project });
    }

    setMyProjectsFlag(value) {
        let project = this.state.searchProject;
        project.myProjectsFlag = value;
        this.setState({ searchProject: project });
    }

    getActiveCurrentTab() {
        const routeUrlTab = this.props.location.pathname.split('/')[2];
        return routesActiveTabMap.includes(routeUrlTab) ? routeUrlTab : '';
    }
    setActiveTabKey(value) {

        const routeActiveTab = this.getActiveCurrentTab();
        if (routeActiveTab) {
            this.setState({ activeTabKey: routeActiveTab });
        } else {
            this.setState({ activeTabKey: value });
        }
        const { context } = this.props;
        if (context.state.projectTab !== null)
            context.setProjectTab(null);
        else
            this.props.match.params.tabId = null;
    }

    setActiveTabKeyOnChange(value) {
        this.setState({ activeTabKey: value })
    }

    setSelectedStationRegion(optionsList, selectedItem) {
        let project = this.state.searchProject;
        project.selectedStationRegions = optionsList.map(item => {
            return item.name
        });
        this.setState({ searchProject: project });
    }

    setSelectedStationAreas(optionsList, selectedItem) {
        let project = this.state.searchProject;
        project.selectedStationAreas = optionsList.map(item => {
            return item.name
        });
        this.setState({ searchProject: project });
    }

    setSelectedPCAreas(optionsList, selectedItem) {
        let project = this.state.searchProject;
        project.selectedPCAreas = optionsList.map(item => {
            return item.name
        });
        this.setState({ searchProject: project });
    }

    setBPID(name) {
        let project = this.state.searchProject;
        project.bpid = name;
        this.setState({ searchProject: project });
    }


    setMPID(name) {
        let project = this.state.searchProject;
        project.mpid = name;
        this.setState({ searchProject: project });
    }

    setWorkOrder(name) {
        let project = this.state.searchProject;
        project.workOrder = name;
        this.setState({ searchProject: project });
    }

    setConstructionStartDate(date) {
        let myDate = null;
        if (date) {
            myDate = date.format('MMMM DD, YYYY');
        }
        let project = this.state.searchProject;

        project.constructionStartDate = myDate;
        this.setState({ searchProject: project });
    }

    setNullConstructionDate() {
        let project = this.state.searchProject;

        project.constructionDateNull = !project.constructionDateNull;
        this.setState({ searchProject: project });
    }

    setCommisioningStartDate(date) {
        let myDate = null;
        if (date) {
            myDate = date.format('MMMM DD, YYYY');
        }
        let project = this.state.searchProject;

        project.commisioningStartDate = myDate;
        this.setState({ searchProject: project });
    }

    setNullCommisioningDate() {
        let project = this.state.searchProject;

        project.commisioningDateNull = !project.commisioningDateNull;
        this.setState({ searchProject: project });
    }

    setCommisioningEndDate(date) {
        let myDate = null;
        if (date) {
            myDate = date.format('MMMM DD, YYYY');
        }
        let project = this.state.searchProject;

        project.commisioningEndDate = myDate;
        this.setState({ searchProject: project });
    }

    setExpectedCloseStartDate(date) {
        let myDate = null;
        if (date) {
            myDate = date.format('MMMM DD, YYYY');
        }
        let project = this.state.searchProject;

        project.expectedCloseStartDate = myDate;
        this.setState({ searchProject: project });
    }

    setNullExpectedDate() {
        let project = this.state.searchProject;

        project.expectedDateNull = !project.expectedDateNull;
        this.setState({ searchProject: project });
    }

    setExpectedCloseEndDate(date) {
        let myDate = null;
        if (date) {
            myDate = date.format('MMMM DD, YYYY');
        }
        let project = this.state.searchProject;

        project.expectedCloseEndDate = myDate;
        this.setState({ searchProject: project });
    }


    setNullInServiceDate() {
        let project = this.state.searchProject;

        project.inServiceDateNull = !project.inServiceDateNull;
        this.setState({ searchProject: project });
    }

    setConstructionEndDate(date) {
        let myDate = null;
        if (date) {
            myDate = date.format('MMMM DD, YYYY');
        }
        let project = this.state.searchProject;

        project.constructionEndDate = myDate;
        this.setState({ searchProject: project });
    }

    setInServiceStartDate(date) {
        let myDate = null;
        if (date) {
            myDate = date.format('MMMM DD, YYYY');
        }
        let project = this.state.searchProject;

        project.inServiceStartDate = myDate;
        this.setState({ searchProject: project });
    }

    setInServiceEndDate(date) {
        let myDate = null;
        if (date) {
            myDate = date.format('MMMM DD, YYYY');
        }
        let project = this.state.searchProject;

        project.inServiceEndDate = myDate;
        this.setState({ searchProject: project });
    }

    onClear() {
        let project = this.state.searchProject;
        this.setState({ searchProject: project });
    }

    // Function for handling switching between card and list views.
    onViewTypeChange = (viewType) => {
        this.setState({ cardview: viewType });
    };

    render() {
        const { history, match, context } = this.props;
        const getFilterSelectionCookieJson = Cookies.get('filters');
        const parsedFilterSelectionsJson = getFilterSelectionCookieJson ? JSON.parse(getFilterSelectionCookieJson) : {};
        const applicationMenu = context.state.userProfile && context.state.userProfile.applicationMenu;
        const myProjectStatus = context.state.userProfile && context.state.userProfile.myProjectStatus;
        const dtApplicationMenu = applicationMenu === 'DATA_ENTRY_TRACKER' || applicationMenu === 'BOTH' || applicationMenu === 'ALL';
        const tclApplicationMenu = applicationMenu === 'CHECKLIST' || applicationMenu === 'BOTH' || applicationMenu === 'ALL';
        const fmpApplicationMenu = applicationMenu === 'FMP_TRACKER' || applicationMenu === 'ALL';
        const tclProjectStatus = ['A', 'C', 'D', 'R', 'U', 'N', 'ALL', 'ADMIN']
        const dtProjectStatus = ['DT_P', 'DT_A', 'DT_N', 'DT_C', 'DT_D', 'DT_ALL', 'DT_H']
        const fmpProjectStatus = ['FMP_P', 'FMP_A', 'FMP_C', 'FMP_R',  'FMP_B', 'FMP_G']
        let defaultMenuOpen = '';
        if (tclProjectStatus.includes(myProjectStatus)) {
            defaultMenuOpen = 'CHECKLIST'
        } else if (dtProjectStatus.includes(myProjectStatus)) {
            defaultMenuOpen = 'DATA_ENTRY_TRACKER'
        } else if (fmpProjectStatus.includes(myProjectStatus)) {
            defaultMenuOpen = 'FMP_TRACKER'
        } else{
            defaultMenuOpen = 'CHECKLIST'
        }

        return (
            <div className="container-fluid">

                <SearchBar stations={this.state.stations}
                    stationRegions={this.state.stationRegions}
                    stationAreas={this.state.stationAreas}
                    pcAreas={this.state.pcAreas}
                    bpIds={this.state.bpIds}
                    mpIds={this.state.mpIds}
                    workOrders={this.state.workOrders}
                    searchProject={this.state.searchProject}
                    onClearSearch={this.onClear.bind(this)}
                    userProfile={context.state.userProfile}
                    activeTabKey={this.state.activeTabKey}
                    context={context}
                    setActiveTabKey={this.setActiveTabKey.bind(this)}
                />

                {/* <Collapse
                    defaultActiveKey={[applicationMenu]}
                    activeKey={this.state.activeCollapsePanels ? this.state.activeCollapsePanels : (applicationMenu=='BOTH')? defaultMenuOpen: applicationMenu}
                    className='site-collapse-custom-collapse'
                    destroyInactivePanel
                    style={{ margin: '16px 16px', border: '0px' }}
                    onChange={(e) => { this.setState({ activeCollapsePanels: e }) }}

                > */}
                {(!isExternalContributorOrExternalView() && dtApplicationMenu) &&

                    // <Collapse.Panel
                    //     header='Data Entry Tracker'
                    //     key='DATA_ENTRY_TRACKER'
                    //     className='site-collapse-custom-panel'
                    //     style={{ marginBottom: 16 }}
                    // >
                    <DataTrackerTabs
                        parsedFilterSelectionsJson={parsedFilterSelectionsJson}
                        history={history} match={match}
                        activeTabKey={this.state.activeTabKey}
                        setActiveTabKeyOnChange={this.setActiveTabKeyOnChange.bind(this)}
                    />
                    // </Collapse.Panel>

                }
                {tclApplicationMenu &&
                    // <Collapse.Panel
                    //     header='Commissioning Checklist'
                    //     key='CHECKLIST'
                    //     className='site-collapse-custom-panel'
                    //     style={{ marginBottom: 16 }}
                    // >
                    <div className="dashboard-tab">
                        <Tabs
                            centered
                            defaultActiveKey={(isExternalContributorOrExternalView() ? "active"
                                : ((parsedFilterSelectionsJson && parsedFilterSelectionsJson.selectedDefaultDashView) ? projectStatusMap[parsedFilterSelectionsJson.selectedDefaultDashView] :
                                    ((parsedFilterSelectionsJson && !parsedFilterSelectionsJson.selectedDefaultDashView) ? 'all' : 'upcoming')))}
 /*                   defaultActiveKey={(isExternalContributorOrExternalView() ? "active" : 'upcoming')}
*/                    onTabClick={(key) => {
                                history.push({
                                    pathname: `/dashboard/${key}`, state: {
                                        station: "",
                                        status: "",
                                        activeTabKey: key
                                    }
                                })
                                this.setActiveTabKeyOnChange(key)
                            }

                            }
                            activeKey={match.params.tabId || (isExternalContributorOrExternalView() ? "active"
                                : this.state.activeTabKey)}
                            /*
                                                activeKey={match.params.tabId || (isExternalContributorOrExternalView() ? "active"
                                                    :  'upcoming')}
                             */
                            tabBarStyle={padfix}
                            tabBarGutter={50}
                            tabBarExtraContent={{left: <div className={'TabPaneTitle'} style={!this.state.activeTabKey.startsWith('datatracker_') && !this.state.activeTabKey.startsWith('fmptracker_')?navMenuHeaderStyle.style1: navMenuHeaderStyle.style0}>Transmission Checklist</div>}}
                        >
                            

                            {!isExternalContributorOrExternalView() &&
                                <TabPane tab={<div className={"TabPaneTitle"}>All</div>} key="all" >

                                </TabPane>
                            }
                            {!isExternalContributorOrExternalView() &&
                                <TabPane tab={<div className={"TabPaneTitle"}>Upcoming</div>} key="upcoming">

                                </TabPane>
                            }
                            {!isExternalContributorOrExternalView() &&
                                <TabPane tab={<div className={"TabPaneTitle"}>In-Development</div>} key="development">

                                </TabPane>
                            }
                            {!isExternalContributorOrExternalView() &&
                                <TabPane tab={<div className={"TabPaneTitle"}>Released</div>} key="release">

                                </TabPane>
                            }
                            <TabPane tab={<div className={"TabPaneTitle"}>Active</div>} key="active">

                            </TabPane>
                            <TabPane tab={<div className={"TabPaneTitle"}>Closed</div>} key="closed">

                            </TabPane>
                            {!isExternalContributorOrExternalView() &&
                                <TabPane tab={<div className={"TabPaneTitle"}>Checklist NA</div>} key="checklist_na">

                                </TabPane>
                            }
                            {/*isCreatorOrAdministrator() &&
                                <TabPane tab={<div className={"TabPaneTitle"}>Admin</div>} key="admin">

                                </TabPane>
                            */}
                        </Tabs>
                    </div>
                    // </Collapse.Panel>
                }
                {(!isExternalContributorOrExternalView() && fmpApplicationMenu) &&
                      <FMPTrackerTabs
                        parsedFilterSelectionsJson={parsedFilterSelectionsJson}
                        history={history} match={match}
                        activeTabKey={this.state.activeTabKey}
                        setActiveTabKeyOnChange={this.setActiveTabKeyOnChange.bind(this)}
                    />
                }
                {/* </Collapse> */}
                {(this.state.activeTabKey === 'fmptracker_all' && fmpApplicationMenu ) &&
                    <FMPTrackerAll context={context} history={history}
                        onViewTypeChange={this.onViewTypeChange}
                        cardview={this.state.cardview}
                        projectList={this.projectsList}
                        ipsStations={this.state.ipsStations}

                        {...this.props} />
                }
                {(this.state.activeTabKey === 'fmptracker_pending' && fmpApplicationMenu) &&
                    <FMPTrackerPending context={context} history={history}
                        onViewTypeChange={this.onViewTypeChange}
                        cardview={this.state.cardview}
                        projectList={this.projectsList}
                        ipsStations={this.state.ipsStations}

                        {...this.props} />
                }
                {(this.state.activeTabKey === 'fmptracker_progress' && fmpApplicationMenu) &&
                    <FMPTrackerProgress context={context} history={history}
                        onViewTypeChange={this.onViewTypeChange}
                        cardview={this.state.cardview}
                        projectList={this.projectsList}
                        {...this.props} />
                }
                {(this.state.activeTabKey === 'fmptracker_review' && fmpApplicationMenu) &&
                    <FMPTrackerReview context={context} history={history}
                        onViewTypeChange={this.onViewTypeChange}
                        cardview={this.state.cardview}
                        projectList={this.projectsList}
                        {...this.props} />
                }
                {(this.state.activeTabKey === 'fmptracker_asbuilts' && fmpApplicationMenu) &&
                    <FMPTrackerASBuilts context={context} history={history}
                        onViewTypeChange={this.onViewTypeChange}
                        cardview={this.state.cardview}
                        projectList={this.projectsList}
                        {...this.props} />
                }
                {(this.state.activeTabKey === 'fmptracker_complete' && fmpApplicationMenu) &&
                    <FMPTrackerComplete context={context} history={history}
                        onViewTypeChange={this.onViewTypeChange}
                        cardview={this.state.cardview}
                        projectList={this.projectsList}
                        {...this.props} />
                }
    
                {(this.state.activeTabKey === 'datatracker_all' && dtApplicationMenu) &&
                    <DataTrackerAll context={context} history={history}
                        onViewTypeChange={this.onViewTypeChange}
                        cardview={this.state.cardview}
                        projectList={this.projectsList}
                        ipsStations={this.state.ipsStations}

                        {...this.props} />
                }
                {(this.state.activeTabKey === 'datatracker_pending' && dtApplicationMenu) &&
                    <DataTrackerPending context={context} history={history}
                        onViewTypeChange={this.onViewTypeChange}
                        cardview={this.state.cardview}
                        projectList={this.projectsList}
                        ipsStations={this.state.ipsStations}

                        {...this.props} />
                }
                {(this.state.activeTabKey === 'datatracker_progress' && dtApplicationMenu) &&
                    <DataTrackerProgress context={context} history={history}
                        onViewTypeChange={this.onViewTypeChange}
                        cardview={this.state.cardview}
                        projectList={this.projectsList}
                        {...this.props} />
                }
                {(this.state.activeTabKey === 'datatracker_hold' && dtApplicationMenu) &&
                    <DataTrackerHold context={context} history={history}
                        onViewTypeChange={this.onViewTypeChange}
                        cardview={this.state.cardview}
                        projectList={this.projectsList}
                        {...this.props} />
                }
                {(this.state.activeTabKey === 'datatracker_na' && dtApplicationMenu) &&
                    <DataTrackerNA context={context} history={history}
                        onViewTypeChange={this.onViewTypeChange}
                        cardview={this.state.cardview}
                        projectList={this.projectsList}
                        {...this.props} />
                }
                {(this.state.activeTabKey === 'datatracker_complete' && dtApplicationMenu) &&
                    <DataTrackerComplete context={context} history={history}
                        onViewTypeChange={this.onViewTypeChange}
                        cardview={this.state.cardview}
                        projectList={this.projectsList}
                        {...this.props} />
                }
                {(this.state.activeTabKey === 'datatracker_matched-duplicate' && dtApplicationMenu) &&
                    <DataTrackerMatchedDuplicate context={context} history={history}
                        onViewTypeChange={this.onViewTypeChange}
                        cardview={this.state.cardview}
                        projectList={this.projectsList}
                        ipsStations={this.state.ipsStations}
                        {...this.props} />
                }
                {(this.state.activeTabKey === 'all' && tclApplicationMenu) &&
                    <All context={context} history={history}
                        onViewTypeChange={this.onViewTypeChange}
                        cardview={this.state.cardview}
                        projectList={this.projectsList}
                        {...this.props} />
                }
                {(this.state.activeTabKey === 'upcoming' && tclApplicationMenu) &&
                    <Upcoming context={context} history={history}
                        onViewTypeChange={this.onViewTypeChange}
                        cardview={this.state.cardview}
                        projectList={this.projectsList}
                        {...this.props} />
                }
                {(this.state.activeTabKey === 'development' && tclApplicationMenu) &&
                    <InDevelopment context={context} history={history}
                        onViewTypeChange={this.onViewTypeChange}
                        cardview={this.state.cardview}
                        projectList={this.projectsList}
                        {...this.props} />
                }
                {(this.state.activeTabKey === 'release' && tclApplicationMenu) &&
                    <Released context={context} history={history}
                        onViewTypeChange={this.onViewTypeChange}
                        cardview={this.state.cardview}
                        projectList={this.projectsList}
                        {...this.props} />
                }
                {(this.state.activeTabKey === 'active' && tclApplicationMenu) &&
                    <Active context={context} history={history}
                        onViewTypeChange={this.onViewTypeChange}
                        cardview={this.state.cardview}
                        projectList={this.projectsList}
                        {...this.props} />
                }
                {(this.state.activeTabKey === 'closed' && tclApplicationMenu) &&
                    <Closed onViewTypeChange={this.onViewTypeChange}
                        context={context} history={history}
                        cardview={this.state.cardview}
                        projectList={this.projectsList}
                        {...this.props} />
                }
                {(this.state.activeTabKey === 'checklist_na' && tclApplicationMenu) &&
                    <ChecklistNA context={context} history={history}
                        onViewTypeChange={this.onViewTypeChange}
                        cardview={this.state.cardview}
                        projectList={this.projectsList}
                        {...this.props} />
                }
                {/*(this.state.activeTabKey === 'admin' && tclApplicationMenu) &&
                    <Admin context={context} history={history}
                        {...this.props} />
                */}
            </div>
        );
    }
}

NavBar.contextType = NavBar;
export default withRouter(NavBar);
